// extracted by mini-css-extract-plugin
export var box = "_8x-1";
export var checked = "_8x-2";
export var descriptionSpacer = "_8x-9";
export var disabled = "_8x-3";
export var icon = "_8x-6";
export var input = "_8x-0";
export var labelSpacer = "_8x-8";
export var medium = "_8x-5";
export var small = "_8x-4";
export var text = "_8x-7";